import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

//Ruler img
import alimentation_grey from '../../Images/Healthform/health_grey.png';
import alimentation_green from '../../Images/Healthform/health_green.png';

class AlimentationDisplay extends Component {
    //Function to display form alimentation alert logo with the good color
    getFormImg(){
        if(this.props.formresAlimentationDisplay.color === "#21BA45"){
            //return green
            return (<img src={alimentation_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="alimentation_logo"/>)
        }
        else{
            //return grey
            return (<img src={alimentation_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="alimentation_logo"/>)
        }
    }

    display_value(){

        let unit = ""

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormImg()
                }
            </Row>
        )
    }

    //Display render
    render(){
        return (
            <div>
                <Col>
                    {this.display_value()}
                </Col>
            </div>
        );
    }
}
export default (AlimentationDisplay);